export const formatAutocompleteResults = (data: string[]): string[] => {
  // The autocomplete API data is in a super weird format.
  // It is an array that contains an array of strings.
  // The first string always seems to be a "0" and all remaining strings are the same value repeated.
  // It looks like this:
  /*
    [
      ["0","brown","brown","brown"],
      ["0","below","below","below"]
    ]
    */
  // We want to flatten it so it looks like this:
  /*
     [
       ["brown"],
       ["below"]
     ]
     */
  const results: string[] = [];

  if (data && data.length > 0) {
    // The sub array is the one with the autocomplete suggestions
    for (const subArray of data) {
      // Make sure to get the last string in the array
      const arrayEnd = subArray.length - 1;
      const suggestion = subArray[arrayEnd];
      results.push(suggestion);
    }
  }

  return results;
};
